/* eslint-disable no-restricted-globals */
import { Store } from "redux";
import {
  getAndroidMessageHandlers,
  getIOSMessageHandlers,
} from "src/utils/in-app/messageHandlers";
import getStore from "src/utils/redux/store";
import { updateForwardedParams } from "src/utils/urlParams";
import goto from ".";
import { globalPush, reroll } from "../components/PageSetRouter";
import { getActivePage } from "../pageSets";

export function pageSetPushReroll(path: string) {
  const state = getStore().getState();
  const { activePageSet, activePage } = getActivePage(path, state);
  if (activePage) {
    goto.pageSet(activePageSet.id, path);
    return;
  }

  reroll(path);
}

export function pushReroll(url: string, check: () => boolean) {
  if (check()) {
    globalPush(url);
  } else {
    reroll(url);
  }
}
export function setParam(
  queryParams: URLSearchParams,
  name: string,
  value?: string | number | boolean
) {
  if (value || value === 0) {
    queryParams.set(name, `${value}`);
  }
}

export function isInsideIOSWebKit(): boolean {
  return !!getIOSMessageHandlers();
}

export function isInsideAndroidWebView(): boolean {
  return !!getAndroidMessageHandlers();
}

/**
 * Helper function for bridging between old code passing upid (query params) and new code (redux).
 * Necessary because users can be rerolled between different code versions.
 * Can be removed once all deployed code is updated to write to and read from redux.
 *
 * If provided with a upid, writes it into the redux store and appends to query params. Otherwise,
 * appends what is in redux to the query params.
 *
 * Mutation warning: `params`
 */
export function forwardUpid(store: Store) {
  const { upid } = store.getState();
  if (upid) {
    updateForwardedParams({ upid });
  }
}
